import React from 'react';
import classNames from 'classnames';
import Icon from 'components/general/Icon/Icon';

const MCInput: React.SFC<MCInputPropDef> = ({
  label,
  name,
  value,
  type,
  checked,
  onChange,
}) => (
  <label
    key={`label-${name}`}
    className="multiple-choice"
  >
    <input
      key={name}
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      checked={checked || false}
      className="multiple-choice__input"
    />
    <span
      className={classNames('multiple-choice__visual-input', {
        'multiple-choice__visual-input--radio': type === 'radio',
      })}
    >
      {type === 'checkbox' && (
        <Icon name="check" type="solid" className="multiple-choice__icon" />
      )}
    </span>
    <span
      htmlFor={name}
      key={`label-${name}`}
      className="multiple-choice__label"
    >
      {label}
    </span>
  </label>
);

interface MCInputPropDef {
  name: string;
  label: string;
  value: string;
  type: 'radio' | 'checkbox';
  checked: boolean;
  onChange(any);
}

export default MCInput;

